export const BaseUrl='https://connect.om.bookseva.com/api'
// export const BaseUrl='http://localhost:5000/api'


export const appVersion = '1.0.4'; 
 